import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

const OutsourcingRisks3 = props => (
    <section id="outsourcing-risks-section3" className="my pt-5">
        <div className='black-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 fw-600 mb-5">{props.t('services:outsourcingRisks:section-3.title')}</h2>
            {[1, 2, 3, 4, 5].map(item => (
                <div key={item} className={item < 5 ? 'mb-5' : ''}>
                    <div className='d-flex align-items-center mb-4'>
                        <div className='arrow-container'>
                            <div className='arrow'>
                                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </div>
                        </div>
                        <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingRisks:section-3.' + item + '.title')}</h3>
                    </div>
                    <p className={item < 5 ? '' : 'm-0'}>
                        <Trans i18nKey={'services:outsourcingRisks:section-3.' + item + '.text'}
                            components={{
                                br: <br />,
                                outsourcingProvider: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_provider.path')} className="link" />
                            }}
                        />
                    </p>
                </div>
            ))}
        </Container>
    </section>
);

export default OutsourcingRisks3;
